import definition from 'task_definition';
global.app.sdk.tasks = global.app.create_sdk(definition,true);
import task_definition from 'task_definition';
global.app.sdk.task = global.app.create_sdk(task_definition, true);

import rmsdefinition from 'rms_definition';
import filedefinition from 'file_definition';
import marketdefinition from 'market_definition';

if(global.app.name === 'task_ui'){
    global.app.sdk.rms = global.app.create_sdk(rmsdefinition, true);
    global.app.sdk.file = global.app.create_sdk(filedefinition, true);
    global.app.sdk.market = global.app.create_sdk(marketdefinition, true);
}

